"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeMetadataCodec = void 0;
const codeMetadata_1 = require("../codeMetadata");
const codeMetadata_2 = require("../typesystem/codeMetadata");
class CodeMetadataCodec {
    decodeNested(buffer) {
        const codeMetadata = codeMetadata_1.CodeMetadata.fromBuffer(buffer.slice(0, codeMetadata_1.CodeMetadataLength));
        return [new codeMetadata_2.CodeMetadataValue(codeMetadata), codeMetadata_1.CodeMetadataLength];
    }
    decodeTopLevel(buffer) {
        const codeMetadata = codeMetadata_1.CodeMetadata.fromBuffer(buffer);
        return new codeMetadata_2.CodeMetadataValue(codeMetadata);
    }
    encodeNested(codeMetadata) {
        return codeMetadata.valueOf().toBuffer();
    }
    encodeTopLevel(codeMetadata) {
        return codeMetadata.valueOf().toBuffer();
    }
}
exports.CodeMetadataCodec = CodeMetadataCodec;
//# sourceMappingURL=codemetadata.js.map